function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M1 50.9949V13.1768H53V50.9949H1ZM27 43.7727C33.527 43.7727 38.8182 38.4815 38.8182 31.9545C38.8182 25.4275 33.527 20.1364 27 20.1364C20.473 20.1364 15.1818 25.4275 15.1818 31.9545C15.1818 38.4815 20.473 43.7727 27 43.7727Z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M26.9999 24.2727C28.262 24.2727 29.4828 24.5788 30.5749 25.1539L30.8985 25.3344L29.0972 28.3882C28.4673 28.0166 27.7502 27.8182 26.9999 27.8182C24.7155 27.8182 22.8636 29.6701 22.8636 31.9545C22.8636 32.4635 22.9548 32.9573 23.1301 33.4198L23.2453 33.6934L20.0294 35.1863C19.5631 34.1817 19.3181 33.0837 19.3181 31.9545C19.3181 27.712 22.7574 24.2727 26.9999 24.2727Z",
  opacity: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.3779 3H36.613L40 10.0909H14L17.3779 3Z",
  opacity: 0.6
});

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    fill: "none",
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.229f1c1e.svg";
export { ForwardRef as ReactComponent };